import { __awaiter, __generator, __spreadArray } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { RemoveIcon, StyledInput } from './_style';
import { Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { Chip, CustomIcon, CustomText, WrapperContainer } from '@corporate-trip-planner-fe/ui-styles';
import { ActionButton } from '@corporate-trip-planner-fe/ui-components';
import ShareTripModal from '../share-trip';
var EmailInviteModal = function (_a) {
    var tripId = _a.tripId, tripName = _a.tripName, onSubmit = _a.onSubmit;
    var _b = useState(''), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState([]), emails = _c[0], setEmails = _c[1];
    var _d = useState({}), emailStatuses = _d[0], setEmailStatuses = _d[1];
    var _e = useState(false), actionLoading = _e[0], setActionLoading = _e[1];
    // Modernized key handling for token input (Enter key)
    var handleKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ',') { // Allow comma or enter for tokenization
            e.preventDefault();
            var email_1 = inputValue.trim().replace(',', '');
            if (email_1 && !emails.includes(email_1) && /^\S+@\S+\.\S+$/.test(email_1)) { // Basic email validation
                setEmails(function (prev) { return __spreadArray(__spreadArray([], prev, true), [email_1], false); });
            }
            setInputValue('');
        }
    };
    var handleRemoveEmail = function (emailToRemove) {
        setEmails(function (prev) { return prev.filter(function (email) { return email !== emailToRemove; }); });
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _a, successful, failed, newStatuses_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(emails.length > 0)) return [3 /*break*/, 2];
                    setActionLoading(true);
                    return [4 /*yield*/, onSubmit(tripId, { invitedEmails: emails })];
                case 1:
                    response = _b.sent();
                    setActionLoading(false);
                    if (response === null || response === void 0 ? void 0 : response.result) {
                        _a = response.result, successful = _a.successful, failed = _a.failed;
                        newStatuses_1 = {};
                        successful.forEach(function (email) {
                            newStatuses_1[email] = { status: 'success' };
                        });
                        failed.forEach(function (failObj) {
                            newStatuses_1[failObj.email] = { status: 'failed', reason: failObj.reason };
                        });
                        setEmailStatuses(newStatuses_1);
                    }
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(WrapperContainer, { "$flexDirection": 'column', "$padding": '1rem 0', children: [_jsx(ShareTripModal, { tripName: tripName }), _jsxs(WrapperContainer, { "$flexDirection": "column", "$gap": "0.5rem", "$padding": "0", children: [_jsx(CustomText, { "$fontSize": "0.9rem", "$fontWeight": "600", children: "Invite Friends via Email" }), _jsx(StyledInput
                    // Updated, clearer placeholder
                    , { 
                        // Updated, clearer placeholder
                        placeholder: "Enter emails (press Enter or comma after each)", value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, onKeyDown: handleKeyDown })] }), emails.length > 0 &&
                _jsx(WrapperContainer, { "$responsive": false, "$flexWrap": 'wrap', "$gap": '8px', "$border": "1px solid #ddd" // Added border for token area
                    , "$borderRadius": "4px", "$padding": "8px", children: emails.map(function (email) {
                        var statusInfo = emailStatuses[email];
                        var isFailed = (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.status) === 'failed';
                        var isSuccess = (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.status) === 'success';
                        return (_jsxs(Chip, { "$isSuccess": isSuccess, "$isFailed": isFailed, children: [email, isFailed && (_jsx(Tooltip, { title: (statusInfo === null || statusInfo === void 0 ? void 0 : statusInfo.reason) || "Failed", children: _jsx(CustomIcon, { "$fontSize": "12px", style: { marginLeft: '4px' }, children: _jsx(InfoOutlined, { fontSize: 'inherit' }) }) })), _jsx(RemoveIcon, { onClick: function () { return handleRemoveEmail(email); }, style: { marginLeft: '8px' }, children: "\u00D7" })] }, email));
                    }) }), _jsx(ActionButton, { variant: "contained" // Use contained variant for primary action
                , color: "primary", loading: actionLoading, onClick: handleSubmit, 
                // Simplified Button Text
                disabled: emails.length === 0, children: "Send Invite" }), _jsx(WrapperContainer, { "$padding": "1rem", "$borderRadius": "4px", "$backgroundColor": "#fff3e0", "$border": "1px solid #ffcc80", "$margin": "1rem 0 0 0", children: _jsx(CustomText, { "$fontSize": "0.8rem", "$color": "#e65100", children: "\u26A0\uFE0F This is a **Private Trip**. Only explicitly invited participants will be able to join." }) })] }));
};
export default EmailInviteModal;
